import { Typography } from "@mui/material";
import Grid from "./Grid";
import Spacebox from "./Spacebox";
import '../css/results.css'
import { isMobile } from "react-device-detect";

const BlurResults = ({ result }) => {
    const formatNum = (num) => parseInt(parseFloat(num).toFixed()).toLocaleString()

    const isSame = () => {

        if (result.lowMonths === 24 && (formatNum(result.lowMonthly) === formatNum(result.highMonthly)))
            return true
        return false
    }

    return (
        <div className="result-display">
            {/** 
             * 💰 Estimated Savings: You could save up to $8,000
             * 💳 New Monthly Payment: $250 – $500
             * ⏳ Estimated Program Duration: 24 – 48 months
            */}
            <Spacebox padding="10px" />
            <Grid grid={result.tier === 'tier 1' || isSame() ? 1 : 2} gap="20px">

                {/* FOR TIER 1 ONLY */}
                {result.tier === 'tier 1' && <div style={{ padding: 15, borderRadius: 10 }} className="option-1">
                    <Typography className=" option-text">
                        <b className="text-white">Option 1</b>
                    </Typography>
                    <Typography style={{ fontSize: isMobile ? '16px' : '23px', filter: 'blur(6px)' }}>
                        <b>Program duration: <span style={{}} className="text-primary">24 Months</span></b>
                    </Typography>
                    <span style={{ fontSize: 50, fontWeight: 600, letterSpacing: '-1px', filter: 'blur(6px)' }} className="text-primary open-sans">${formatNum(result.highMonthly - (result.highMonthly * 0.2))}</span>
                    <Typography style={{ fontSize: '23px', filter: 'blur(6px)' }}>
                        <b>New monthly payment</b>
                    </Typography>
                    <div style={{ borderRadius: '10px', padding: '10px', background: '#a2cfff', textAlign: 'center', marginTop: '-20px', zIndex: 10, position: 'relative' }}>
                        <small>Complete your quick verification call to unlock your personalized plan details</small>
                    </div>
                </div>}

                {/* FOR Tier 2 - 4 */}
                {result.tier !== 'tier 1' && <div style={{ padding: 15, borderRadius: 10 }} className="option-1">
                    <Typography className=" option-text">
                        <b className="text-white">Option 1</b>
                    </Typography>
                    <Typography style={{ fontSize: isMobile ? '16px' : '23px', filter: 'blur(6px)' }}>
                        <b>Program duration: <span style={{}} className="text-primary">24 Months</span></b>
                    </Typography>
                    <span style={{ fontSize: isMobile ? 30 : 50, fontWeight: 600, letterSpacing: '-1px', filter: 'blur(6px)' }} className="text-primary open-sans">${formatNum(result.highMonthly - (result.highMonthly * 0.2))}</span>
                    <Typography style={{ fontSize: isMobile ? 16 : '23px', filter: 'blur(6px)' }}>
                        <b>New monthly payment</b>
                    </Typography>
                    <div style={{ borderRadius: '10px', padding: '10px', background: '#a2cfff', textAlign: 'center', marginTop: '-20px', zIndex: 10, position: 'relative', fontSize: isMobile ? '12px' : '16px' }}>
                        <small>Complete your quick verification call to unlock your personalized plan details</small>
                    </div>
                </div>}
                {(result.tier !== 'tier 1' && !isSame()) && <div style={{ padding: 15, borderRadius: 10 }} className="option-2">
                    <Typography className=" option-text">
                        <b className="text-white">Option 2</b>
                    </Typography>
                    <Typography style={{ fontSize: isMobile ? '16px' : '23px', filter: 'blur(6px)' }}>
                        <b>Program duration: <span style={{}} className="text-primary">{result.lowMonths} Months</span></b>
                    </Typography>
                    <span style={{ fontSize: isMobile ? 30 : 50, fontWeight: 600, letterSpacing: '-1px', filter: 'blur(6px)' }} className="text-primary open-sans">${formatNum(result.lowMonthly - (result.lowMonthly * 0.2))}</span>
                    <Typography style={{ fontSize: isMobile ? 16 : '23px', filter: 'blur(6px)' }}>
                        <b>New monthly payment </b>
                    </Typography>
                    <div style={{ borderRadius: '10px', padding: '10px', background: '#ffc670', textAlign: 'center', marginTop: '-20px', zIndex: 10, position: 'relative', fontSize: isMobile ? '12px' : '16px' }}>
                        <small>Complete your quick verification call to unlock your personalized plan details</small>
                    </div>
                </div>}
            </Grid>
        </div>
    );
}

export default BlurResults;